import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { css, withStyles } from '../../assets/styles/withStyles';

class NotFound extends PureComponent {
  render() {
    const { styles } = this.props;

    return (
      <div {...css(styles.container)}>
        <p {...css(styles.title)}>404</p>
        <p {...css(styles.text)}>Are you lost?</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(() => ({
    container: {
      position: 'fixed',
      top: 0,
      right: 0,
      left: '33%',
      bottom: 0,
      overflow: 'scroll',
      padding: 20
    },
    title: {
      fontSize: 35
    },
    text: {
      fontSize: 27,
      marginBottom: 50
    }
  }))(NotFound)
);



// WEBPACK FOOTER //
// ./src/containers/404/index.js